import { Box, Typography } from "@mui/joy";

import type { CalendarEvent } from "./TimeGridView";
import { getStatusColor } from "./utils";

const glassSx = {
    border: "1px solid",
    borderColor: "rgba(128, 128, 128, 0.2)",
    borderRadius: "4px",
    bgcolor: "background.surface",
} as const;

interface EventBlockProps {
    event: CalendarEvent;
    compact?: boolean;
    /** Absolute positioning for timed grid blocks */
    positioned?: {
        top: number;
        height: number;
    };
    onClick: (event: CalendarEvent, e: React.MouseEvent) => void;
}

export function EventBlock({ event, compact, positioned, onClick }: EventBlockProps) {
    const accent = getStatusColor(event.taskStatus || "NOT-STARTED");

    return (
        <Box
            onClick={(e) => onClick(event, e)}
            sx={{
                ...glassSx,
                position: positioned ? "absolute" : "relative",
                left: positioned ? 4 : undefined,
                right: positioned ? 4 : undefined,
                top: positioned?.top,
                height: positioned?.height,
                zIndex: positioned ? 1 : undefined,
                px: compact ? 0.75 : 1,
                py: compact ? 0.25 : 0.5,
                overflow: "hidden",
                cursor: "pointer",
                borderLeft: "2px solid",
                borderLeftColor: accent,
                transition: "border-color 0.15s ease, background-color 0.15s ease",
                "&:hover": {
                    borderColor: "rgba(128, 128, 128, 0.35)",
                    borderLeftColor: accent,
                    bgcolor: "background.level1",
                },
            }}
        >
            <Typography
                level="body-xs"
                sx={{
                    fontWeight: 600,
                    color: "text.primary",
                    lineHeight: 1.25,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
            >
                {event.title}
            </Typography>
            {!compact && event.time && (
                <Typography
                    level="body-xs"
                    sx={{
                        color: "text.tertiary",
                        lineHeight: 1.2,
                        mt: 0.15,
                    }}
                >
                    {event.time}
                </Typography>
            )}
        </Box>
    );
}
